import { moment, TIME_SIMPLE } from '../../../../shared/i18n/date-time/moment';

export const formatBookingTimePreservingSelection = (
	date: Date,
	selectedTime?: string,
) => {
	if (selectedTime) {
		return moment(selectedTime, 'HH:mm').format(TIME_SIMPLE);
	}

	return moment(date).format(TIME_SIMPLE);
};
